import { render, staticRenderFns } from "./dropdown-collapse.vue?vue&type=template&id=65720bd0&scoped=true&"
import script from "./dropdown-collapse.vue?vue&type=script&lang=js&"
export * from "./dropdown-collapse.vue?vue&type=script&lang=js&"
import style0 from "./dropdown-collapse.vue?vue&type=style&index=0&id=65720bd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65720bd0",
  null
  
)

export default component.exports